import React, { useState } from "react";
import style from "./index.module.scss";
import { Button, Input } from "antd";
import {
    filteredStuListAtom,
    paramsAtom,
    searchTextAtom,
    showModalAtom
} from "../../../../../service/stores/RollCallStore";
import { useAtomValue, useSetAtom } from "jotai";
import { exportStuMark } from "../../../../../service/rollCall";

export default function RollCallHeader() {
    const setSearchText = useSetAtom(searchTextAtom);
    const [text, setText] = useState("");
    const showModal = useSetAtom(showModalAtom);
    const stuList = useAtomValue(filteredStuListAtom);
    const { weekTimeId } = useAtomValue(paramsAtom);

    return (
        <div className={style.root}>
            <div className={style.count}>共 {stuList.length} 人</div>

            <div className={style.tools}>
                <Input
                    className={style.input}
                    value={text}
                    onChange={e => setText(e.target.value)}
                    placeholder="请输入要搜索学生的姓名或学号"
                    onPressEnter={() => setSearchText(text)}
                />
                <Button
                    className={style.search}
                    type="primary"
                    onClick={() => setSearchText(text)}>
                    查询
                </Button>
                <Button
                    className={style.export}
                    type="primary"
                    ghost
                    onClick={() => exportStuMark(weekTimeId)}>
                    导出数据
                </Button>
                <Button
                    className={style.random}
                    type="primary"
                    onClick={() => showModal(true)}>
                    随机选人
                </Button>
            </div>
        </div>
    );
}
